const wowApp = require('angular').module('oly.common');

wowApp.directive('lazyLoadComponent', ['SettingsService', '$document', '$timeout', '$compile', require('./lazyloadcomponent.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/lazy-load-component/index.js